import {
  filterPeople,
  isPersonComplete,
  isRowFilled,
  validatePhoneNumber,
} from './bridgeStaff';

export { filterPeople as filterCompanyBridgeAdmins };

export function validateCompanyBridgeAdmins(admins) {
  if (!admins?.length) {
    return 'Please add at least one admin.';
  }

  // Every visible row must be complete (empty + rows must be filled or removed).
  const emails = [];
  for (let i = 0; i < admins.length; i++) {
    const p = admins[i];
    const label = `Admin ${i + 1}`;
    if (!isRowFilled(p) || !isPersonComplete(p)) {
      return `${label}: name, email, country code, and phone are required.`;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email.trim())) {
      return `${label}: invalid email.`;
    }
    const phoneErr = validatePhoneNumber(p, label);
    if (phoneErr) return phoneErr;
    const em = p.email.trim().toLowerCase();
    if (emails.includes(em)) {
      return `Duplicate email "${p.email}" among admins.`;
    }
    emails.push(em);
  }
  return null;
}
